<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
      <div class="daojia-navbar-left" @click="$router.go(-1)"><span class="icon-chevron-left"></span></div>
      <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img
            src="../../assets/img/global/logo.png"></a></h1>
      <div class="daojia-navbar-right">
      </div>
    </div>
    <div class="title">
      <h1>服务介绍及收费详情</h1>
    </div>
    <div class="filling">
      <div>
        <p class="text-center">请根据您的行李量和物品种类选择合适的邮寄线路目前我们提供两种渠道：</p>

        <div>
          <div class="h2line">
            <h2><span>绿色专线</span></h2>
          </div>
          <div class="statement">
            <ul>
              <li>1个月左右到达（受疫情影响航班量减少可能会出现延迟）</li>
              <li>
                需要本人身份证正反面照片。</li>
              <li>只能邮寄使用过的衣服和鞋子。</li>
              <li>
                单个包裹价值不超过1000人民币。</li>
            </ul>
          </div>
        </div>
        <div>
          <div class="h2line">
            <h2>Aupost代寄</h2>
          </div>
          <div class="statement">
            <ul>
              <li>10-20个工作日到达（受疫情影响航班量减少可能会出现延迟）</li>
              <li>
                适合行李相对较杂的客人。</li>
              <li>
                不需要提供任何材料，但收件人和回国本人要保持一致。</li>
              <li>
                澳洲邮政链接中国EMS方式，不通过我司战略合作伙伴清关，如遇海关查验等一切问题，客人需要亲自或委托清关公司处理。</li>
              <li>价值超过1000人民币，客人需要如实申报，如果海关查验，可能需要补交关税或其他额外费用，由收件人承担。因此不建议客人邮寄过于贵重的物品，如果一定需要，建议购买相应保险（保费为物品价值的5%）。</li>
            </ul>
          </div>
        </div>
        <div class="h2line">
          <h2>收费</h2>
        </div>
        <div class="statement">
          <h3 class="text_title item">邮寄统一价格</h3>
          <div class="serve text-center item">
            <div class="weui-flex serve_title ">
              <div class="weui-flex__item ">重量</div>
              <div class="weui-flex__item ">价格</div>
            </div>
            <div class="class= weui-flex serve">
              <div class="weui-flex__item">
                2KG以下
              </div>
              <div class="weui-flex__item">$40</div>
            </div>
            <div class="weui-flex serve">
              <div class="weui-flex__item">
                2KG以上（绿色专线）
              </div>
              <div class="weui-flex__item">$17.5 / KG</div>
            </div>
            <div class="weui-flex serve">
              <div class="weui-flex__item">
                2KG以上（ Aupost ）
              </div>
              <div class="weui-flex__item">$16 / KG</div>
            </div>
          </div>
          <div class="serve_replenish item">
            <p>以每 0.5kg 为单位，不足 0.5kg 按 0.5kg 算，</p>
            <p>如：16.4kg 算作 16.5kg, 17.7kg 算作 18kg</p>
          </div>
          <h3 class="text_title item">上门取件及打包分拣</h3>
          <div class="serve text-center item">
            <div class="weui-flex serve_title ">
              <div class="weui-flex__item ">基础收费</div>
              <div class="weui-flex__item ">回程费</div>
            </div>
            <div class="class= weui-flex serve">
              <div class="weui-flex__item">
                $60 / 小时
              </div>
              <div class="weui-flex__item"> $50 起</div>
            </div>
          </div>
        </div>
      </div>

      <div>
        (以上报价均为现金价格，本公司有信用卡、支付宝、微信小程序、线下转账、现金等多种支付方式，所有支付方式均需支付额外百分之十的GST，其中现金支付有百分之十的折扣)
      </div>
    </div>
    <div class="btn-box">
      <div class="btn-container">
        <div class="btn active" @click="$router.go(-1)">返回</div>
      </div>
    </div>
    <img :src="pixelURL('qingjie', 'baojia')" class="hide">
</div>
</template>

<script>
export default {
  name: 'work',
  data() {
    return {
      order: {}
    }
  },
  methods: {

  },
  components: {
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

@font-face {
  font-family: sans-serif;
  font-style: normal;
  font-weight: normal;
}

html,
body {
  margin: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.container {
  padding-top: 50px;
}

.title {
  font-size: 1.4em;
}

h2 {
  color: #ff7444;
  text-align: center;
}

.item {
  padding: 0 0 20px 0;
}

.filling {
  padding: 10px 20px 10px 20px;
  margin: 0 0 10px 0;
}

.empty {
  padding: 0 20vw;
  text-align: center;
  margin-top: 2vh;
  width: 100vw;
  box-sizing: border-box;
  color: #999;

  a {
    color: #fe9567;
  }
}

.image-box {
  img {
    width: 100%;
  }

  font-size:0;
}

.btn {
  margin-top: 20px;
}

.text {
  text-align: center;
  font-size: 1.2em;
  color: #888;
}

.daojia-navbar {
  position: fixed;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 10px;
  box-sizing: border-box;
  height: 50px;
}

.daojia-navbar-left {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: left;

  span {
    font-size: 2em;
    color: #666;
  }
}

.daojia-navbar-middle_logo img {
  height: 34px;
}

.daojia-navbar-middle {
  display: block;
  -webkit-box-flex: 2;
  -webkit-flex: 2;
  flex: 2;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: sans-serif;
  font-size: 1.2em;
  line-height: 1.3;
  font-weight: bold;
}

.daojia-navbar-right {
  font-size: 14px;
  line-height: 26px;
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: right;
}

.btn-box-fix .btn.active {
  margin-left: 0;
}

.title {
  background-image: url(../../../static/img/baggage/price_01_bg.png);
  background-size: cover;
  background-position: center;
  padding: 8vh 3.5vw 8vh 3.5vw;
  color: #f5f5f5;

  h1 {
    font-size: 7vw;
  }
}

.h2line {
  margin: 20px 0 0 0;
  text-align: center;
}

.h2line h2 {
  display: flex;
  align-items: center;
}

h2::before,
h2::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid;
}

h2::before {
  margin-right: 10px;
}

h2::after {
  margin-left: 10px;
}

h2 span {
  color: #ff7444;
}

.statement {
  padding: 20px 0 20px 0;

  ul {
    list-style: none;
    counter-reset: list-item;
  }

  li {
    font-size: 4vw;
    line-height: 7vw;
    text-indent: -5vw;
    margin-left: 5VW;
  }

  li::before {
    font-size: 5vw;
    font-weight: bold;
    color: #ffffff;
    content: counter(list-item) " ";
    margin-right: 5px;
    font-family: sans-serif;
    -webkit-text-stroke: 0.2vw #ff7444;
    filter: drop-shadow(1px 1px 0 #ff7444);
  }


  .rough {
    font-size: 5vw;
    font-weight: 500;

    span {
      font-size: 7vw;
      font-weight: 600;
    }
  }
}

.text_title {
  margin: 0;
  font-family: sans-serif;
  -webkit-text-stroke: 0.2vw #ff7444;
  filter: drop-shadow(1px 1px 0 #ff7444);
  font-size: 6vw;
  color: #fff;
  position: relative;
  display: inline-block;
  padding:10px 0 10px 0;
}

.serve {
  line-height: 10vw;
  font-size: 4vw;
  color: #5A5E68;
  border: none;

  .serve_title {
    background-color: #F8F9FB;
  }

  div {
    border-style: solid;
    border-color: #d0d0d05b;
    border-width: 0.1px;
    margin-bottom: -0.2px;
  }

}

.serve_replenish {
  text-align: center;
  font-size: 3vw;
  color: #888888;
}
</style>



// WEBPACK FOOTER //
// src/pages/baggage/price.vue